const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const { isVideoType } = require('lib/video')
const { getPortfolioThumbUrl } = require('module/user/helpers/get_portfolio_thumb_url')
const log = require('log').create('portfolio', 'thumb') // eslint-disable-line

function PortfolioThumb({ item, onClick }, { globals }) {
    const url = getPortfolioThumbUrl(item, globals)

    const style = {}
    if (url) {
        style.backgroundImage = `url(${url})`
    }

    const is_video = isVideoType(item.type)
    const className = classNames([
        'portfolio-item',
    ], {
        'portfolio-video-item': is_video,
        'portfolio-image-item': ! is_video,
    })

    return (
        <li
            className={className}
            style={style}
            onClick={onClick}
            />
    )
}

PortfolioThumb.propTypes = {
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
}
PortfolioThumb.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = PortfolioThumb
